import i18n from 'i18n';

const storeCardTranslation = {
    ru: {
        "loading": "Загрузка",
        "LOADING": "Загрузка",
        "noCoupons": "Нет купонов",
        "coupon": "Купон",
        "generateNew": "Создать",
        "download": "Скачать",
        "createdPass": "Созданный талон",
        "createdPasses": "Созданные талоны",
        // Creator
        "stripImage": "Горизонтальное изображение",
        "primaryField": "Основное поле",
        "createCouponTemplate": "Создание шаблона купона",
        "CreateCouponTemplate": "Создать шаблон посадочного талона",
        "allowAnonymous": "Разрешить анонимным пользователям",
        "transitType": "Тип транзита",
        "changeField": "Изменить поле",
        "addField": "Добавить поле",
        "allowModification": "Разрешить изменение",
        "alignment": "Выравнивание",
        "Left": "Слева",
        "Center": "По центру",
        "Right": "Справа",
        "Justified": "Упрощенно",
        "Natural": "Натурально",
        "key": "Ключ",
        "label": "Ярлык",
        "value": "Значение",
        "changeMessage": "Сообщение при изменении поля",
        "needToAdd": "Необходимо добавить",
        "cannotAddMore": "Невозможно добавить больше",
        "cannotRemoveMore": "Невозможно удалить",
        "outOf": "из",
        "locationsAdded": "локаций добавлено",
        "proximityUuid": "UUID радиомаяка",
        "major": "Major",
        "minor": "Minor",
        "relevantText": "Релевантный текст",
        "addLocation": "Добавить локацию",
        "altitude": "Высота",
        "latitude": "Широта",
        "longitude": "Долгота",
        "serialNumber": "Серийный номер",
        "PDF417": "PDF417",
        "QR": "QR",
        "Aztec": "Aztec",
        "Code128": "Code128",
        "messageSource": "Источник содержания",
        "customKey": "Собственный ключ",
        "messageSourceKey": "Ключ содержания",
        "useAsAlt": "Использовать содержание для подписи",
        "altText": "Альтернативный текст",
        "AIR": "Самолет",
        "TRAIN": "Поезд",
        "BUS": "Автобус",
        "BOAT": "Лодка",
        "GENERIC": "Иное",
        "verboseName": "Название",
        "description": "Описание",
        "expirationDate": "Срок годности",
        "relevantDate": "Дата и время исполнения",
        "appLaunchUrl": "Ссылка на приложение",
        "associatedStoreID": "Ассоциированный с картой ID в App Store",
        "logoText": "Текст возле логотипа",
        "maxDistance": "Дистанция срабатывания",
        "logoImage": "Логотип",
        "iconImage": "Иконка",
        "footerImage": "Изображение в футере",
        "foregroundColor": "Цвет содержания",
        "labelColor": "Цвет ярлыков",
        "backgroundColor": "Цвет фона",
        "fields": "Поля",
        "originField": "Поле отправления",
        "destinationField": "Поле прибытия",
        "headerFields": "Поля в шапке",
        "secondaryFields": "Вторичные поля",
        "auxiliaryFields": "Дополнительные поля",
        "backFields": "Поля на задней стороне карты",
        "ibeaconList": "Список радиометок",
        "locationList": "Список локаций",
        "barcodeList": "Список баркодов",
        "generatePass": "Сгенерировать",
        "fieldsAdded": "полей добавлено",
        "addIBeacon": "Добавить радиометку",
        "barcodeFormat": "Формат баркода",
        "format": "Формат",
        // template list
        "createTemplate": "Создать шаблон",
        "noAvailablePasses": "Нет доступных карт",
        // template details
        "edit": "Редактировать",
        "generateNewAdmin": "Создать карту (админ)",
        "generateNewClient": "Создать карту (клиент)",
        // template create
        "editTemplate": "Редактировать шаблон",
        "saveTemplate": "Сохранить шаблон",
        // pass create
        "specialSection": "Специальная секция",
    },
    en: {
        "loading": "Loading",
        "LOADING": "Loading",
        "noCoupons": "No coupons",
        "coupon": "Coupon",
        "generateNew": "Generate",
        "download": "Download",
        "createdPass": "Created pass",
        "createdPasses": "Created passes",
        // Creator
        "stripImage": "Strip image",
        "primaryField": "Primary field",
        "createCouponTemplate": "Create coupon template",
        "allowAnonymous": "Allow anonymous generation",
        "transitType": "Transit type",
        "changeField": "Change field",
        "addField": "Add field",
        "allowModification": "Allow modification",
        "alignment": "Alignment",
        "Left": "Left",
        "Center": "Center",
        "Right": "Right",
        "Justified": "Justified",
        "Natural": "Natural",
        "key": "Key",
        "label": "Label",
        "value": "Value",
        "changeMessage": "Message on change",
        "needToAdd": "Need to add",
        "cannotAddMore": "You can't add more",
        "cannotRemoveMore": "You can't remove more",
        "outOf": "out of",
        "locationsAdded": "locations added",
        "proximityUuid": "Proximity UUID",
        "major": "Major",
        "minor": "Minor",
        "relevantText": "Relevant text",
        "addLocation": "Add location",
        "altitude": "Altitude",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "serialNumber": "Serial number",
        "PDF417": "PDF417",
        "QR": "QR",
        "Aztec": "Aztec",
        "Code128": "Code128",
        "messageSource": "Source of message",
        "customKey": "Custom key",
        "messageSourceKey": "Key of message source",
        "useAsAlt": "Use message as alternative text",
        "altText": "Alternative text",
        "AIR": "Airplane",
        "TRAIN": "Train",
        "BUS": "Bus",
        "BOAT": "Boat",
        "GENERIC": "Other",
        "verboseName": "Verbose name",
        "description": "Description",
        "expirationDate": "Expiration date",
        "relevantDate": "Relevant date",
        "appLaunchUrl": "Application launch url",
        "associatedStoreID": "Associated store ID",
        "logoText": "Logo text",
        "maxDistance": "Maximum distance",
        "logoImage": "Logo image",
        "iconImage": "Icon image",
        "footerImage": "Footer image",
        "foregroundColor": "Foreground colour",
        "labelColor": "Label colour",
        "backgroundColor": "Background colour",
        "fields": "Fields",
        "originField": "Origin fields",
        "destinationField": "Destination fields",
        "headerFields": "Header fields",
        "secondaryFields": "Secondary fields",
        "auxiliaryFields": "Auxiliary fields",
        "backFields": "Back fields",
        "ibeaconList": "List of iBeacons",
        "locationList": "List of locations",
        "barcodeList": "List of Barcodes",
        "generatePass": "Generate",
        "fieldsAdded": "fields added",
        "addIBeacon": "Add iBeacon",
        "barcodeFormat": "Barcode format",
        "format": "Format",
        // template list
        "createTemplate": "Create template",
        "noAvailablePasses": "No available passes",
        // template details
        "edit": "Edit",
        "generateNewAdmin": "Generate new (admin)",
        "generateNewClient": "Generate new (client)",
        // template create
        "editTemplate": "Edit template",
        "saveTemplate": "Save template",
        // pass create
        "specialSection": "Special section",
    }
}
i18n
    .addResourceBundle('ru', 'storeCard', storeCardTranslation.ru)
    .addResourceBundle('en', 'storeCard', storeCardTranslation.en)